<app-document-subheader/>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      <div class="page-container">
        <div class="card card-light w-100">

          <div class="card-body">
            <div class="container-fluid">
              @if (cashJournalModel$ |async; as cashJournalModel) {
                <div class="row mb-2">
                  <div class="col">
                    <app-badge
                      [color]="'primary'"
                      [message]="'CASH_JOURNAL_LBL_BALANCE'  | translate : {balance: cashJournalModel.balance |showSignValueType: 'Monetary'}"
                      [needTranslation]="false"
                    />
                  </div>
                </div>

                <app-generic-grid
                  [data]="cashJournalModel.cashJournalEntries"
                  [tabViewName]="'cashJournalEntries'"
                  (onActionClickedSetRowData)="onSetRowData($event)"
                />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
